<script lang="ts">
    import { onDestroy } from 'svelte'
    import { afterNavigate, beforeNavigate, goto } from '$app/navigation'
    import { resolve } from '$app/paths'
    import { page } from '$app/state'
    import { getAuthenticatedRedirectPath } from '$lib/routing/auth-routing.js'
    import { getAppServices } from '$lib/services/app-services.js'

    const { auth } = getAppServices()

    const unsubscribe = auth.subscribe(({ current, previous }) => {
        if (
            previous.phase !== 'admitting' ||
            previous.loginKind !== 'oauth' ||
            current.phase !== 'authenticated'
        ) {
            return
        }

        const destination = getAuthenticatedRedirectPath(page.url)
        const destinationPathname = new URL(destination, page.url).pathname

        if (destinationPathname !== resolve('/home')) {
            auth.beginPreservedSocialLoginNavigation()
        }
    })

    beforeNavigate(({ cancel, to }) => {
        if (
            auth.preservedSocialLoginNavigation.phase !== 'pending' ||
            to?.route.id !== null ||
            to.url.origin !== page.url.origin
        ) {
            return
        }

        cancel()
        auth.rejectPreservedSocialLoginNavigation()
        void goto(resolve('/home'), { replaceState: true })
    })

    afterNavigate(() => {
        if (auth.preservedSocialLoginNavigation.phase !== 'pending') {
            return
        }

        if (page.status === 403 || page.status === 404) {
            auth.rejectPreservedSocialLoginNavigation()
            void goto(resolve('/home'), { replaceState: true })
            return
        }

        if (page.status >= 400) {
            auth.completePreservedSocialLoginNavigation()
            return
        }

        if (page.url.pathname === resolve('/home')) {
            auth.rejectPreservedSocialLoginNavigation()
            return
        }

        auth.completePreservedSocialLoginNavigation()
    })

    onDestroy(unsubscribe)
</script>
